var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 9,
    viewBox: "0 0 8 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.76183 1.17789L4.96951 3.97021C4.96459 3.97491 4.96059 3.98066 4.95788 3.9872C4.95014 4.00588 4.95442 4.02739 4.96872 4.04169L7.76149 6.83468C7.76152 6.83472 7.76156 6.83476 7.7616 6.8348C7.87809 6.95319 7.94984 7.11542 7.94984 7.29452C7.94984 7.65654 7.65638 7.94999 7.29437 7.94999C7.11533 7.94999 6.95315 7.87826 6.83491 7.762C6.83485 7.76194 6.83479 7.76188 6.83473 7.76182L4.04164 4.96873C4.02212 4.9492 3.99046 4.9492 3.97093 4.96873L1.17736 7.76206L1.17735 7.76205L1.17676 7.76266C1.05753 7.88597 0.890475 7.96255 0.705469 7.96255C0.343458 7.96255 0.05 7.66909 0.05 7.30709C0.05 7.12209 0.126583 6.95507 0.250134 6.83561L0.250139 6.83562L0.250737 6.83502L3.0439 4.04164C3.06343 4.02211 3.06343 3.99046 3.0439 3.97093L0.250573 1.17736L0.250578 1.17735L0.249972 1.17676C0.12666 1.05753 0.050074 0.890475 0.050074 0.705469C0.050074 0.343458 0.343539 0.05 0.705543 0.05C0.890535 0.05 1.05756 0.126583 1.17702 0.250134L1.17701 0.250139L1.17761 0.250737L3.97099 3.0439C3.99052 3.06343 4.02217 3.06343 4.0417 3.0439L6.83469 0.251136C6.83473 0.2511 6.83477 0.251064 6.8348 0.251028C6.95319 0.13454 7.11543 0.0627768 7.29453 0.0627768C7.65654 0.0627768 7.95 0.356242 7.95 0.718246C7.95 0.897299 7.87826 1.05948 7.76199 1.17773C7.76194 1.17778 7.76188 1.17783 7.76183 1.17789Z",
    fill: "#BCBDC0",
    stroke: "white",
    strokeWidth: 0.1,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.7a521daf4288a6f1636f47e225dc8321.svg";
export { ForwardRef as ReactComponent };